'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state) {
    this.$http = $http;
    this.$state = $state;
    this.newConf = {};
  }

  $onInit() {
    
  }

  add() {
    this.$http.post(`api/deviceconfigs`, this.newConf).then(response => {
      this.$state.go('deviceconfigs');
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/deviceconfigs/add/add.controller.js